import React from 'react';

type OverviewCustomerSectionProps = {
  walkInLabel: string;
  customerName?: string;
  phone?: string;
  emailAddress?: string;
};

const OverviewCustomerSection: React.FC<OverviewCustomerSectionProps> = ({
  walkInLabel,
  customerName,
  phone,
  emailAddress,
}) => {
  if (!customerName) {
    return (
      <div className="right">
        <span data-hj-suppress className="customer-name">
          {walkInLabel}
        </span>
      </div>
    );
  }

  return (
    <div className="right">
      <span data-hj-suppress className="customer-name">
        {customerName}
      </span>
      {phone && (
        <span className="overview-row">
          <span className="icon icons-action-phone" />
          <span className="customer-phone">{phone}</span>
        </span>
      )}
      {emailAddress && (
        <span className="overview-row">
          <span className="icon icons-action-email" />
          <span className="customer-email">{emailAddress}</span>
        </span>
      )}
    </div>
  );
};

export default OverviewCustomerSection;
